module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAYCAMAAAAMEmfoAAAAQlBMVEX/sZKbQxWkRRasRxi9TB33oH7DTx/WYDLkdkzNVif6p4axSBnbZzrof1b0mHXIUiPwkGvfbkP9rI23ShvSWyzsiGFWE8z4AAAAAXRSTlPM0jRW/QAAAClJREFUeF4FwIUNwCAAALDCXPH/XyWobptfNnxOxevQXZLdqnksoigIExmaAOv6CdTpAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./assets/images/percent-female.png
// module id = 524
// module chunks = 0